<template>
    <div>
    
        <Fallback>
            <picture>
                <source media="(orientation: portrait)" srcset="../assets/img/fallback/10_NSC_Anim_iPad_P.jpg">
                <source media="(orientation: landscape)" srcset="../assets/img/fallback/10_NSC_Anim_iPad_L.jpg">
                <!-- The img element is required as the last child tag of the picture declaration block. The img element is used to provide backward compatibility for browsers that do not support the picture element, or if none of the source tags matched. -->
                <img src="../assets/img/fallback/Infobox.png" alt="">
            </picture>          
        </Fallback>

    </div>
</template>



<script>
    export default {
        name: 'NSC_Anim',
        babylonState: {
            moveCamera: [-8.7, .8, 14, 15 ,0.1,2],    
            //moveCamera: [-9.5,1.5,15.5, 27,2.5,1.3],


            Geo_Tschernobyl: {

                children: {

                    BG_Sphere: true,
                    
                    Geo_Beton_Sarkophag: false,
                    Geo_Beton_Sarkophag_Rost: true,
                    Geo_Schattenplane_Betonsarkophag: true,
                    Geo_Textur1_Reaktor_4_Damage: false,
                    Geo_Textur1_Reaktor_4_Damage_Aussen: false,
                    Geo_Textur1_Reaktor_4_Damage_Innen: false,

                    Geo_Neuer_Sarkophag_anim: true,

                    Geo_Neuer_Sarkophag_transparent: false,
            
                    Geo_Schienen_Sarkophag: true,
                    Geo_Schattenplane_NSC_anim: true,
                    Geo_Schattenplane_NSC: false,


                    Geo_Elbphilharmonie_Basis: false,
                    Geo_Elbphilharmonie_Dach: false,
                    Geo_Elbphilharmonie_Glas: false,
                    Geo_Elbphilharmonie_Mitte: false,
                    Geo_Elbphilharmonie_Sockel: false,

                    Geo_GrosserTurm_Gestaenge1: false,
                    Geo_GrosserTurm_Schlot1: false,
                    Geo_GrosserTurm_RoteStreifen1: false,
                    Geo_GrosserTurm_Schattenplane: false,

                    Geo_KleinerTurm_Geruest1: true,
                    Geo_KleinerTurm_Schlot1: true,
                    Geo_KleinerTurm_RoteStreifen1: true,
                    Geo_KleinerTurm_Schattenplane: true, 
                    
          

                },

            },

            fire: false
        },

        babylonReady: function () {

            //this.$audioController.initTrack('speaker', require('./../assets/audio/Uebergang_01.mp3'), false, true);

            //this.$babylonController.goToAnimation("Anim_Neuer_Sarkophag", 0),
            this.$babylonController.startAnimation("Anim_Neuer_Sarkophag", false,.3),
            //this.$babylonController.goToAnimation("Anim_Schattenplane_NSC", 0),
            this.$babylonController.startAnimation("Anim_Schattenplane_NSC", false, .3),
            this.$babylonController.setAutoRotateBehaviour(true),
            this.$babylonController.setCameraRadiusLimit (9,50),
            this.$babylonController.zoomCamera(1.8)
            
        },

    }
</script>

<style scoped lang="scss">

    .fallback-container .hotspot {
        
        left: 65vw;
        top: 40vh;

        @media (orientation: landscape) {
            left: 60vw;
            top: 35vh;
            transform: scale(0.75);            
        }
    }


</style>
